import {useMemo} from 'react';
import {countries, CountryCodeType} from '../model';
import {useParamState} from './useParamState';

export const useCountryParam = () => {
  const [params, setParam] = useParamState<{country: string}>();

  const country = useMemo(() => {
    if (params.country) {
      const countryCode = params.country?.toUpperCase();
      const matchingCountry = Object.values(countries).find(
        (c) => c.code === countryCode,
      );
      return matchingCountry ?? countries.SE;
    }

    const browserLangCode = navigator.language.split('-')[0];
    const languageCode = browserLangCode === 'no' ? 'nb' : browserLangCode; // Browsers return "no" instead of "nb"
    const matchingCountry = Object.values(countries).find(
      (c) => c.language === languageCode,
    );
    return matchingCountry ?? countries.SE;
  }, [params]);

  const setCountry = (countryCode: CountryCodeType) => {
    if (params?.country !== countryCode) setParam('country', countryCode);
  };

  return {country, setCountry};
};
